import React from 'react';
import styled from 'styled-components';
import { SimpleSingleDropdown } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import type { Item } from '@grnhse/seedling/lib/birch/components/forms/dropdown';
import { withLocalePrefix } from 'shared/utils/translation';
import { PAGE_SIZE_OPTIONS } from 'talent_matching/page_size_options';

const t = withLocalePrefix('talent_matching');

const PageSizeSelectorWrapper = styled.div`
  width: 280px;
`;

type Props = {
  rowsPerPage: number;
  onRowsPerPageChange: (rowsPerPage: number) => void;
};

const pageSizeItems = PAGE_SIZE_OPTIONS.map((count) => ({
  label: t('table.footer.rows_per_page', { count }),
  value: count,
}));

const PageSizeSelector = ({ rowsPerPage, onRowsPerPageChange }: Props) => {
  const selectedItem =
    pageSizeItems.find((item) => item.value === rowsPerPage) ??
    ({
      label: t('table.footer.rows_per_page', { count: rowsPerPage }),
      value: rowsPerPage,
    } as Item<number>);

  return (
    <PageSizeSelectorWrapper>
      <SimpleSingleDropdown<number>
        data-provides="talent-matching-page-size"
        ariaLabel={selectedItem.label}
        items={pageSizeItems}
        selectedItem={selectedItem}
        onSelectedItemChange={(item) => onRowsPerPageChange(item.value)}
        clearable={false}
      />
    </PageSizeSelectorWrapper>
  );
};

export default PageSizeSelector;
